/** ERP dashboard chart builders — pipeline, status donut, ranked (AnalyticsChartCard) */

export const KPI_VARIANTS = ['forest', 'copper', 'forest', 'copper'];

export function withKpiVariants(kpis = []) {
  return kpis.map((kpi, index) => ({
    ...kpi,
    variant: kpi.variant || KPI_VARIANTS[index % KPI_VARIANTS.length],
  }));
}

export function buildDashboardCharts({ pipeline, status, ranked } = {}) {
  const charts = [];
  if (pipeline?.rows?.length || pipeline?.alwaysShow) {
    charts.push({ variant: 'pipeline', ...pipeline, rows: pipeline.rows || [] });
  }
  if (status && (status.active > 0 || status.inactive > 0 || status.alwaysShow)) {
    charts.push({ variant: 'status', ...status });
  }
  if (ranked?.rows?.length || ranked?.alwaysShow) {
    charts.push({ variant: 'ranked', ...ranked, rows: ranked.rows || [] });
  }
  return charts;
}

/** Sum row values whose labels match any active keyword (case-insensitive). */
export function statusFromChartRows(rows = [], activeKeywords = []) {
  const keys = activeKeywords.map((k) => k.toLowerCase());
  let active = 0;
  let inactive = 0;

  rows.forEach((row) => {
    const label = String(row.label || '').toLowerCase();
    const value = Number(row.value) || 0;
    if (keys.some((key) => label.includes(key))) active += value;
    else inactive += value;
  });

  return { active, inactive };
}

export function pipelineFromKpis(items = []) {
  return items
    .filter((item) => item.label != null)
    .map(({ label, value }) => ({ label, value: Number(value) || 0 }));
}

export function sumRowValues(rows = []) {
  return rows.reduce((sum, row) => sum + (Number(row.value) || 0), 0);
}
